import { Action } from '@ngrx/store';
import { ApplicationUpdatePermissions } from '../model/application/application-update-permissions.model';
import { SignInfo } from '../../../core/model/authorization/sign-info.model';
import { AuthorizationStatus } from '../../../core/model/authorization/authorization-status.model';
import { AuthorizationResponse } from '../../../core/model/authorization/authorization-response.model';
import { AuthorizationSecurityError } from '../../../core/model/authorization/authorization-security-error.enum';
import { ApplicationDetail } from '../model/application/application-detail.model';

// initial POST
export const UPDATE_PERMISSIONS_REQUEST = '[Application] Update Permissions Request';
export const UPDATE_PERMISSIONS_SUCCESS = '[Application] Update Permissions Success';
export const UPDATE_PERMISSIONS_ERROR =   '[Application] Update Permissions Error';

// popup close
export const UPDATE_PERMISSIONS_CANCEL =      '[Application] Update Permissions Cancel';
export const UPDATE_PERMISSIONS_AUTH_ERROR =  '[Application] Update Permissions Auth Error';

// MEP authorization in IFrame
export const UPDATE_PERMISSIONS_AUTH_FINISHED = '[Application] Update Permissions Auth Finished';

// finalization GET status
export const UPDATE_PERMISSIONS_STATUS_REQUEST = '[Application] Update Permissions Status Request';
export const UPDATE_PERMISSIONS_STATUS_SUCCESS = '[Application] Update Permissions Status Success';
export const UPDATE_PERMISSIONS_STATUS_ERROR =   '[Application] Update Permissions Status Error';

// clean state
export const UPDATE_PERMISSIONS_CLEAN =  '[Application] Update Permissions Clean';

/**
 * Request to update application permissions.
 */
export class UpdatePermissionsRequestAction implements Action {
    readonly type = UPDATE_PERMISSIONS_REQUEST;

    constructor(public payload: ApplicationDetail) {}
}

/**
 * Application update permissions request success.
 * MEP authorization follows.
 */
export class UpdatePermissionsSuccessAction implements Action {
    readonly type = UPDATE_PERMISSIONS_SUCCESS;

    constructor(public payload: ApplicationUpdatePermissions) {}
}

/**
 * Error when updating permissions application.
 */
export class UpdatePermissionsErrorAction implements Action {
    readonly type = UPDATE_PERMISSIONS_ERROR;

    constructor(public payload: any) {}
}

// ---------------------------------------------------------------------------------------------------------------------

/**
 * Cancel update permissions application.
 */
export class UpdatePermissionsCancelAction implements Action {
    readonly type = UPDATE_PERMISSIONS_CANCEL;
}

/**
 * Authorization error.
 */
export class UpdatePermissionsAuthErrorAction implements Action {
    readonly type = UPDATE_PERMISSIONS_AUTH_ERROR;

    constructor(public payload: AuthorizationSecurityError) {}
}

/**
 * IFrame authorization finished.
 */
export class UpdatePermissionsAuthFinishedAction implements Action {
    readonly type = UPDATE_PERMISSIONS_AUTH_FINISHED;

    constructor(public payload: AuthorizationResponse) {};
}

// ---------------------------------------------------------------------------------------------------------------------

/**
 * Get authorization status - it is required to fetch authorization status from BE.
 */
export class UpdatePermissionsStatusRequestAction implements Action {
    readonly type = UPDATE_PERMISSIONS_STATUS_REQUEST;

    constructor(public payload: SignInfo) {}
}

/**
 * Get authorization status - success.
 *
 * Success means that status has been fetched. It does not mean successful authorization in MEP.
 * Payload contains MEP authorization status / result.
 */
export class UpdatePermissionsStatusSuccessAction implements Action {
    readonly type = UPDATE_PERMISSIONS_STATUS_SUCCESS;

    constructor(public payload: AuthorizationStatus) {}
}

/**
 * Get authorization status - error.
 */
export class UpdatePermissionsStatusErrorAction implements Action {
    readonly type = UPDATE_PERMISSIONS_STATUS_ERROR;

    constructor(public payload: any) {}
}

// ---------------------------------------------------------------------------------------------------------------------

/**
 * Clean authorization store.
 */
export class UpdatePermissionsCleanAction implements Action {
    readonly type = UPDATE_PERMISSIONS_CLEAN;
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions
    = UpdatePermissionsRequestAction
    | UpdatePermissionsSuccessAction
    | UpdatePermissionsErrorAction
    | UpdatePermissionsCancelAction
    | UpdatePermissionsAuthErrorAction

    | UpdatePermissionsAuthFinishedAction

    | UpdatePermissionsStatusRequestAction
    | UpdatePermissionsStatusSuccessAction
    | UpdatePermissionsStatusErrorAction
    | UpdatePermissionsCleanAction;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/applications/actions/application-update-permissions.actions.ts